/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：LocalStorageのストア
 *
 * 作成者：2022/1/6 ノア）黄
 * 最終修正者：2022/1/6 ノア）黄
 *
 */
import {
  setLocalStorage,
  getLocalStorage,
  setSessionStorage,
  getSessionStorage,
  clearLocalStorage,
  clearSessionStorage
} from '@/utils/localStorageUtils'
import { UserInfo } from '@/models'

const local = {
  itpConnectValidFlag: '0', // ITP接続許可フラグ
  loginCheck: false, // ログインチェック
  userInfo: {} as UserInfo // ユーザーのアクセストークン
}

export const localService = new Proxy(local, {
  get(target, key) {
    return getLocalStorage(key as string)
  },
  set(target, key, value) {
    setLocalStorage(key as string, value)
    return Reflect.set(target, key, value)
  }
})

const session = Object.assign({}, local)

export const sessionService = new Proxy(session, {
  get(target, key) {
    return getSessionStorage(key as string)
  },
  set(target, key, value) {
    setSessionStorage(key as string, value)
    return Reflect.set(target, key, value)
  }
})

export const clearLocal = (): void => {
  clearLocalStorage()
}

export const clearSession = (): void => {
  clearSessionStorage()
}
